import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_tasks.visualization_access"))),
      ]),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: {
                    click: function ($event) {
                      return _vm.getItems()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-reload"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.update"))),
                ],
                1
              ),
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.downloadMassive },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("icon-download"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.download"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        [
          _c(VDataTable, {
            staticClass: "table-inca",
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              expanded: _vm.expanded,
              "item-key": "name",
              "single-expand": "",
              "hide-default-footer": "",
              "items-per-page": _vm.pagination.limit,
              page: _vm.pagination.current,
            },
            on: {
              pagination: function ($event) {
                _vm.pagination.total = $event.itemsLength
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.pagination, "current", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function (data) {
                  return [
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.clickedRow(data.item)
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-view")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("my_tasks.email_details"))),
                        ]),
                      ]
                    ),
                    _c(
                      VTooltip,
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "btn-icon-inca",
                                          attrs: { icon: "", small: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showModalUserAccessNew(
                                                data
                                              )
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c(VIcon, [_vm._v("icon-add")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("my_tasks.new_email"))),
                        ]),
                      ]
                    ),
                    _c(
                      VMenu,
                      {
                        attrs: {
                          rigth: "",
                          "offset-x": "",
                          small: "",
                          dense: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    VBtn,
                                    _vm._g(
                                      _vm._b(
                                        { attrs: { icon: "", small: "" } },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(VIcon, [
                                        _vm._v("mdi-dots-vertical"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          VList,
                          { attrs: { dense: "", small: "" } },
                          [
                            _c(
                              VListItem,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.showModalUserAccessObject(data)
                                  },
                                },
                              },
                              [
                                _c(
                                  VIcon,
                                  { staticClass: "mr-1", attrs: { small: "" } },
                                  [_vm._v("mdi-format-list-checks")]
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("my_tasks.permission"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VListItem,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.showModalUserAccessLogs(data)
                                  },
                                },
                              },
                              [
                                _c(
                                  VIcon,
                                  { staticClass: "mr-1", attrs: { small: "" } },
                                  [_vm._v("mdi-book-open")]
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("my_tasks.audit_logs"))),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              VListItem,
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadData(data.item)
                                  },
                                },
                              },
                              [
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-download"),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("my_tasks.download_csv"))
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "expanded-item",
                fn: function (ref) {
                  var item = ref.item
                  var headers = ref.headers
                  return [
                    _c(
                      "td",
                      {
                        staticStyle: { padding: "0px !important" },
                        attrs: { colspan: headers.length },
                      },
                      [_c("user-access-details", { attrs: { record: item } })],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-vue", { attrs: { pagination: _vm.pagination } }),
      _c(
        "DialogsComponent",
        {
          ref: _vm.modalUserAccessObject,
          attrs: { title: _vm.texts.permission, width: 800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [_c("user-access-objects", { attrs: { record: _vm.record } })],
            1
          ),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: _vm.modalUserAccessNew,
          attrs: { title: _vm.texts.new_email, width: 800 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("user-access-new", {
                ref: _vm.modalUserAccessNew + "_body",
                attrs: { record: _vm.record },
              }),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$refs[_vm.modalUserAccessNew + "_body"].handleSubmit()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-check-circle-outline"),
                  ]),
                  _vm._v(_vm._s(_vm.$t("btns.accept"))),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: _vm.modalUserAccessLogs,
          attrs: { title: _vm.texts.logs, width: 720 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [_c("user-access-logs", { attrs: { record: _vm.record } })],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }